import './setupResizeObserver'
import React from 'react'
import ReactDOM from 'react-dom'
import './assets/locales/i18n'
import { store } from './redux/store'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import { Spin } from 'antd'
import App from './App'
import { Loading3QuartersOutlined } from '@ant-design/icons'
import { bootstrapStoredThemeAppearance } from './theme/useThemeSwitcher'

bootstrapStoredThemeAppearance()

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>,
  document.getElementById('root')
)

Spin.setDefaultIndicator(<Loading3QuartersOutlined style={{ fontSize: 30 }} spin />)

